import {
  applySlideoutHostLayout,
  getHostBridge,
  removeSlideoutHostLayout,
} from "@frontend/hostContract"

import {WIDGET_SLIDEOUT_WIDTH} from "./styles"

const MOBILE_BREAKPOINT = 768

export const applySlideoutLayout = (): void => {
  if (getHostBridge()?.displayMode !== "slideout") return
  if (window.innerWidth < MOBILE_BREAKPOINT) return
  applySlideoutHostLayout(WIDGET_SLIDEOUT_WIDTH)
}

export const removeSlideoutLayout = (): void => {
  removeSlideoutHostLayout()
}
